import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ModalRef} from "../../../tandem-core/models/modal-ref";
import {DialogService} from "../../../tandem-core/services/dialog.service";

@Component({
  selector: 'tandem-vision-dialog',
  templateUrl: './vision-dialog.component.html',
  styleUrls: ['./vision-dialog.component.scss']
})
export class VisionDialogComponent implements OnInit{


  currentVision: string = '';
  maxChars: number = 500;
  characterCount: number = 0;

  visionForm: FormGroup = new FormGroup<any>({});
  public modalRef?: ModalRef
  constructor(private fb: FormBuilder,
              private dialogService: DialogService) {
  }

  ngOnInit(): void {
    this.characterCount = this.currentVision.length;
    this.visionForm = this.fb.group({
      myVision: [this.currentVision, [Validators.required, Validators.maxLength(500)]]
    });
    this.visionForm.get('myVision')?.valueChanges.subscribe(vision => {
      this.characterCount = vision.length;
      if (vision.length >= 500)  {
        vision = vision.slice(0, 500);
        this.visionForm.get('myVision')?.setValue(vision);
      }
    })
  }

  close() {
    this.modalRef?.close();
    this.dialogService.closeModal2();
  }

  submit() {
    this.modalRef?.close(this.visionForm.get('myVision')?.value);
    this.dialogService.closeModal2();
  }
}
